import { ControllerPaletteColor } from './__palette-color';

export enum ControllerTypographyColor {
  Default = ControllerPaletteColor.Gray100,
  Light = ControllerPaletteColor.Gray400,
  Primary = ControllerPaletteColor.Ngb500,
  Secondary = ControllerPaletteColor.GrayWhite,
}
